import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzCardModule } from 'ng-zorro-antd/card';
import { AccountDeletionComponent } from '../account-deletion/account-deletion.component';

@Component({
  selector: 'app-account-settings-danger',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    NzCardModule,
    AccountDeletionComponent,
  ],
  templateUrl: './account-settings-danger.component.html',
  styleUrl: './account-settings-danger.component.less'
})
export class AccountSettingsDangerComponent {}
